import { Badge } from '@/components/ui/badge';

const STATUS_CONFIG: Record<
  string,
  { variant: 'default' | 'secondary' | 'destructive' | 'outline'; label: string; dotColor: string }
> = {
  draft: { variant: 'secondary', label: 'Draft', dotColor: 'bg-muted-foreground' },
  active: { variant: 'default', label: 'Active', dotColor: 'bg-green-500' },
  closed: { variant: 'outline', label: 'Closed', dotColor: 'bg-muted-foreground/50' },
};

interface PollStatusBadgeProps {
  status: string;
}

export function PollStatusBadge({ status }: PollStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.draft;

  return (
    <Badge variant={config.variant} className="gap-1.5">
      <span className={`h-1.5 w-1.5 rounded-full ${config.dotColor}`} />
      {config.label}
    </Badge>
  );
}
